// redux
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import api from "../config/api";
import config from "../config/config";
import { getCurrentLoggedInSessionToken } from "../config/userPool";

const {
  CAMPAIGN_CONFIGURATION_MODULE_CONFIGURATION_ENDPOINT,
  CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT,
  CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT,
  CAMPAIGN_CONFIGURATION_EARNING_LIMIT_PERIOD_ENDPOINT,
  CAMPAIGN_CONFIGURATION_GLOBAL_CONFIG_ENDPOINT

} = config.api_endpoint;

const initialState = {
  loading: false,
};


export const fetchModuleConfigurationList = createAsyncThunk(
  "campaign_configuration/fetchModuleConfigurationList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIGURATION_MODULE_CONFIGURATION_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchRewardProviderList = createAsyncThunk(
  "campaign_configuration/fetchRewardProviderList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchRewardProviderDetail = createAsyncThunk(
  "campaign_configuration/fetchRewardProviderDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const fetchCampaignCategoryList = createAsyncThunk(
  "campaign_configuration/fetchCampaignCategoryList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchCampaignCategoryDetail = createAsyncThunk(
  "campaign_configuration/fetchCampaignCategoryDetail",
  async (id, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.get(
        CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT + "/" + id,
        {},
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const fetchEarningLimitPeriodList = createAsyncThunk(
  "campaign_configuration/fetchEarningLimitPeriodList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIGURATION_EARNING_LIMIT_PERIOD_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const fetchGlobalConfigList = createAsyncThunk(
  "campaign_configuration/fetchGlobalConfigList",
  async (_, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      let url = `${CAMPAIGN_CONFIGURATION_GLOBAL_CONFIG_ENDPOINT}`;

      const results = await api.get(url, {}, token);

      return results;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const updateGlobalConfig = createAsyncThunk(
  "campaign_configuration/updateGlobalConfig",
  async ({ data }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${CAMPAIGN_CONFIGURATION_GLOBAL_CONFIG_ENDPOINT}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const updateModuleConfigurationStatus = createAsyncThunk(
  "campaign_configuration/updateModuleConfigurationStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${CAMPAIGN_CONFIGURATION_MODULE_CONFIGURATION_ENDPOINT}/${id}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const updateCampaignCategoryStatus = createAsyncThunk(
  "campaign_configuration/updateCampaignCategoryStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT}/${id}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


export const updateEarningLimitPeriodStatus = createAsyncThunk(
  "campaign_configuration/updateEarningLimitPeriodStatus",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      const results = await api.put(
        `${CAMPAIGN_CONFIGURATION_EARNING_LIMIT_PERIOD_ENDPOINT}/${id}`,
        JSON.stringify(data),
        `Bearer ${token}`
      );
      return results;

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const createAndUpdateCampaignRewardProvider = createAsyncThunk(
  "campaign_configuration/createAndUpdateCampaignRewardProvider",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      if (id) {
        const results = await api.put(
          `${CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const deleteCampaignRewardProviderById = createAsyncThunk(
  "campaign_configuration/deleteCampaignRewardProviderById",
  async (id, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
          `${CAMPAIGN_CONFIGURATION_REWARDS_PROVIDER_ENDPOINT}/${id}`,
        "",
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);



export const createAndUpdateCampaignCategory = createAsyncThunk(
  "campaign_configuration/createAndUpdateCampaignCategory",
  async ({ data, id }, { rejectWithValue }) => {
    try {
      const token = getCurrentLoggedInSessionToken();
      if (id) {
        const results = await api.put(
          `${CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT}/${id}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      } else {
        const results = await api.post(
          `${CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT}`,
          JSON.stringify(data),
          `Bearer ${token}`
        );
        return results;

      }

    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);




export const deleteCampaignCategoryById = createAsyncThunk(
  "campaign_configuration/deleteCampaignCategoryById",
  async (id, { rejectWithValue }) => {
    try {

      const token = getCurrentLoggedInSessionToken();
      const results = await api.remove(
          `${CAMPAIGN_CONFIGURATION_CAMPAIGN_CATEGORY_ENDPOINT}/${id}`,
        "",
        `Bearer ${token}`
      );

      return results.data;
    } catch (error) {
      return rejectWithValue(error.details);
    }
  }
);


const campaignConfigurationSlice = createSlice({
  name: "campaign_configuration",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchModuleConfigurationList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchModuleConfigurationList.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(fetchModuleConfigurationList.rejected, (state, action) => {
        state.loading = false;
      })
  },
});

const CampaignConfigurationReducer = campaignConfigurationSlice.reducer;
export default CampaignConfigurationReducer;
